"use strict";
/**
 * フォームデータをsessionStorageで管理するユーティリティ
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPaymentError = exports.loadPaymentError = exports.savePaymentError = exports.clearFormData = exports.loadFormData = exports.saveFormData = void 0;
var STORAGE_KEY = 'form_data';
var ERROR_STORAGE_KEY = 'payment_error';
/**
 * フォームデータをsessionStorageに保存
 */
function saveFormData(data) {
    try {
        // クレジットカード情報は保存しない
        var safeData = __assign({}, data);
        delete safeData.card_number;
        delete safeData.card_cvc;
        delete safeData.card_exp;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(safeData));
    }
    catch (e) {
        console.warn('Failed to save form data to sessionStorage:', e);
    }
}
exports.saveFormData = saveFormData;
/**
 * フォームデータをsessionStorageから取得
 */
function loadFormData() {
    try {
        var data = sessionStorage.getItem(STORAGE_KEY);
        if (data) {
            return JSON.parse(data);
        }
    }
    catch (e) {
        console.warn('Failed to load form data from sessionStorage:', e);
    }
    return null;
}
exports.loadFormData = loadFormData;
/**
 * フォームデータのsessionStorageエントリを削除
 */
function clearFormData() {
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(ERROR_STORAGE_KEY);
}
exports.clearFormData = clearFormData;
/**
 * 決済エラーメッセージをsessionStorageに保存
 */
function savePaymentError(message) {
    try {
        sessionStorage.setItem(ERROR_STORAGE_KEY, message);
    }
    catch (e) {
        console.warn('Failed to save payment error to sessionStorage:', e);
    }
}
exports.savePaymentError = savePaymentError;
/**
 * 決済エラーメッセージをsessionStorageから取得
 */
function loadPaymentError() {
    try {
        return sessionStorage.getItem(ERROR_STORAGE_KEY);
    }
    catch (e) {
        console.warn('Failed to load payment error from sessionStorage:', e);
        return null;
    }
}
exports.loadPaymentError = loadPaymentError;
/**
 * 決済エラーメッセージのsessionStorageエントリを削除
 */
function clearPaymentError() {
    sessionStorage.removeItem(ERROR_STORAGE_KEY);
}
exports.clearPaymentError = clearPaymentError;
